<template>
    <div 
        class="o-units-figures"
    >
        <!-- Here point -->

        <div v-if="getDenormalisedTerminal && terminalId">
            <MapLabel
                :selectedUnit="getDenormalisedTerminal.unit.name"
                target="unit"
                :offsetX="0"
                :offsetY="0"
                position-x="middle"
                position-y="middle"
            >
                <APMapHerePoint />
            </MapLabel>
        </div>

        <!-- Here line -->

        <div v-if="getDenormalisedTerminal && terminalId">
            <MapLabel
                v-if="activeFloorUnitName"
                :selectedUnit="activeFloorUnitName"
                target="unit"
                :offsetX="offsetXHereLine"
                :offsetY="offsetYHereLine"
                position-x="left"
                position-y="middle"
                :fixed-x="xPositioHereLine"
                :fixed-y="yPositioHereLine"
            >
                <OUnitsLine
                    :style="aMapHerePointParams.styles"
                    :start-unit="activeFloorUnitName"
                    :finish-unit="getDenormalisedTerminal.unit.name"
                    :custom-start-positons="floorLabelPositionName && floorLabelPositionName !== 'unit'"
                    :widthCut="aMapHerePointParams.params.width_cut"
                    :animation="aMapHerePointParams.params.animation"
                />
            </MapLabel>
        </div>

        <!-- Floor label -->

        <div>
            <MapLabel
                v-for="floor in activeBuildingGroupFloorsLevels"
                :key="floor.unit.name"
                :selectedUnit="floorLabelUnits[floor.meta.level] || activeBuildingGroupOneUnitNamePerFloor[floor.id]"
                target="unit"
                :offsetX="floorLabelPositionOffsetX"
                :offsetY="0"
                :position-x="floorLabelPosition.positionX"
                :position-y="floorLabelPosition.positionY"
                :fixed-x="getFloorLabelPositionX()"
                :fixed-y="getFloorLabelPositionY()"
            >
                <APFloorLabel 
                    :floor-number="floor.meta.level"
                    :is-show-here-icon="getDenormalisedTerminal && floor.meta.level == getDenormalisedTerminal.floor.level"
                    :componentStyle="{
                        ...aPFloorLabelParams.styles,
                        backgroundColor: floorColor[floor.meta.level]

                    }"
                    :componentParams="aPFloorLabelParams.params"
                    :start-unit="activeFloorUnitName"
                    :finish-unit="getDenormalisedTerminal.unit.name"
                    :custom-start-positons="floorLabelPositionName && floorLabelPositionName !== 'unit'"
                    :class="'floor-label__' + floorLabelPositionName"
                    v-if="isShowFloorLabel(floor.meta.level)"
                    @iconCreate="calculateLabelPositions"
                />
            </MapLabel>
            <!-- TEST LABEL -->
            <!-- <MapLabel
                v-for="floor in activeBuildingGroupFloorsLevels"
                :key="floor.unit.level"
                :selectedUnit="floorLabelUnits[floor.meta.level] || activeBuildingGroupOneUnitNamePerFloor[floor.id]"
                target="unit"
                :offsetX="0"
                :offsetY="0"
                position-x="middle"
                position-y="middle"
                :fixed-x="getFloorLabelPositionX()"
                :fixed-y="getFloorLabelPositionY()"
            >
                <div style="width: 2px; height: 2px; background-color: red"></div>
            </MapLabel> -->
            <!-- TEST LABEL -->
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import OUnitsLine from "../o-units-line/o-units-line"
import APMapHerePoint from "../../atoms/a-p-map-here-point"
import APFloorLabel from "../../atoms/a-p-floor-label/a-p-floor-label"
import MapLabel from "../../../shared/components/map-viewer/labels/map-label"

import posterLineAngle from '../../../utils/mixins/poster-line-angle'

import FLOOR_LABEL_POSITIONS from '../../../utils/constants/floor-label-positions'

export default {
    name: "OUnitsFigures",
    inject: ['mapViewer'],
    mixins: [posterLineAngle],
    components: {
        MapLabel,
        OUnitsLine,
        APFloorLabel,
        APMapHerePoint
    },
    props: {

    },
    data() {
        return {
            aMapHerePointParams: {},
            aPFloorLabelParams: {},
            activeBuildingIds: [],

            floorLabelPositionOffsetX: 0,
            xPositioHereLine: null,
            yPositioHereLine: null,
            offsetXHereLine: 0,
            offsetYHereLine: 0,
            test: false
        }
    },
    computed: {
        ...mapState({
            terminalId: state => state.terminalId
        }),
        ...mapGetters([
            'getMapConfigProp',
            'getMapConfigProp',
            'getDenormalisedTerminal'
        ]),
        activeFloorUnitName() {
            return this.floorLabelUnits[
                this.activeBuildingGroupFloors.find(f => 
                    f.meta.level == this.getDenormalisedTerminal.floor.level 
                    && this.activeBuildingGroupOneUnitNamePerFloor[f.floor.id]
                )?.meta.level
            ]
        },
        floorLabelUnits() {
            return this.getMapConfigProp('map_views.poster.floor_label_units', {});
        },
        activeBuildingGroupFloors(){
            return this.activeFloors.filter( f => this.activeBuildingGroupIds.includes(f.floor.building_group_id));
        },
        activeBuildingGroupIds(){
            return this.activeBuildings?.map(b => b?.meta.building_group_id);
        },
        activeBuildingGroupOneUnitNamePerFloor(){
            return this.portals.reduce( (acc, p) => {
                if(!acc[p.floor.id]){
                    acc[p.floor.id] = p.unit.name;
                }
                return acc;
            }, {})
        },
        activeBuildings(){
            return this.buildings.filter( b => this.activeBuildingIds.includes(b.meta.building_index))
        },
        buildings(){
            return this.mapViewer.mapData.objects.filter( o => o.type === 'building');
        },
        activeFloors() {
            return this.floors.filter(floor => this.activeBuildingIds.includes(floor.meta.building_index) && this.activeLevels.includes(floor.meta.level))
        },
        activeLevels() {
            return [...this.getMapConfigProp('map_views.poster.active_levels', []), ...this.figuresActiveFloors];
        },
        excludeLevels() {
            return this.getMapConfigProp('map_views.poster.exclude_levels', []);
        },
        floors(){
            return this.mapViewer.mapData.objects.filter( o => o.type === 'floor');
        },
        portals(){
            return this.mapViewer.mapData.objects.filter( o => o.type === 'portal');
        },
        floorLabelPositionName() {
            return this.getMapConfigProp('map_views.poster.floor_label_position', 'left');
        },
        floorLabelPosition() {
            return FLOOR_LABEL_POSITIONS[this.floorLabelPositionName]
        },
        activeBuildingGroupFloorsLevels() {
            return _.uniqBy(this.activeBuildingGroupFloors, 'meta.level')
        },
        floorColor() {
            return this.getMapConfigProp(`map_views.poster.floor_color`, {})
        },
        componentParams() {
            return this.getMapConfigProp('components.OUnitsFigures.params') || {};
        },
        figuresActiveFloors() {
            return this.componentParams.active_levels || []
        }
    },
    methods: {
        calculateLabelPositions() {
            if(this.floorLabelPositionName == 'left') {
                this.xPositioHereLine = this.getActiveFloorElementWidth() - this.getHereIconHalfWidth();
                this.yPositioHereLine = null

                this.offsetXHereLine = 0;
                this.offsetYHereLine = 0;
            }

            if(this.floorLabelPositionName == 'right') {
                this.xPositioHereLine = this.getMapWidth() - this.getActiveFloorElementWidth() + this.getHereIconHalfWidth();
                this.yPositioHereLine = null

                this.offsetXHereLine = 0;
                this.offsetYHereLine = 0;
            }

            if(this.floorLabelPositionName == 'top') {
                this.xPositioHereLine = null
                this.yPositioHereLine = this.getActiveFloorElementHalfHeight()

                this.offsetXHereLine = -this.getHereIconHalfWidth();
                this.offsetYHereLine = 0;
            }

            if(this.floorLabelPositionName == 'bottom') {
                this.xPositioHereLine = null
                this.yPositioHereLine = this.getMapHeight() - this.getActiveFloorElementHalfHeight();

                this.offsetXHereLine = -this.getHereIconHalfWidth();
                this.offsetYHereLine = 0;
            }

            if(this.floorLabelPositionName == 'unit') {
                this.xPositioHereLine = null
                this.yPositioHereLine = null

                this.offsetXHereLine = 0;
                this.offsetYHereLine = 0;

                this.floorLabelPositionOffsetX = -this.getHereIconHalfWidth()
            }
            this.$nextTick(() => {
                this.$bus.$emit('on_camera_update')
            })
        },
        getComponentsParams(componentName) {
            return {
                styles: {
                    ...this.getMapConfigProp(`components.${componentName}.styles`),
                    ...this.getMapConfigProp(`views.${this.view}.${componentName}.styles`)
                },
                params: {
                    ...this.getMapConfigProp(`components.${componentName}.params`),
                    ...this.getMapConfigProp(`views.${this.view}.${componentName}.params`)
                }
            }
        },
        getFloorLabelPositionX() {
            if(this.floorLabelPositionName == 'right') {
                return this.getMapWidth()
            }
            return this.floorLabelPosition.fixedX
        },
        getFloorLabelPositionY() {
            if(this.floorLabelPositionName == 'bottom') {
                return this.getMapHeight()
            }
            return this.floorLabelPosition.fixedY
        },
        isShowFloorLabel(level) {
            return !this.excludeLevels.includes(level) 
        }
    },
    created() {
        this.activeBuildingIds = this.getMapConfigProp('map_views.poster.active_building_ids', []);
        this.aPFloorLabelParams = this.getComponentsParams('APFloorLabel', {params: {}, styles: {}});
        this.aMapHerePointParams = this.getComponentsParams('AMapHerePoint', {params: {}, styles: {}});
        setTimeout(() => {
            this.test = 1
        }, 15000)
    }
}
</script>

<style lang="scss">
@import "o-units-figures";
</style>
